<template>
<!-- DBより読み込み -->
<div v-if="state === 1">
	<h2>{{ first_list.anketo_name }}</h2>
	<!-- <p>{{ first_list.anketo_message }}</p> -->
	<!-- <div> -->
		<div class="myinput_area">
			<p class="center">{{ first_list.anketo_message }}</p>
			<dl v-for="(ank, index) in ank_lists" :key="ank.id">
				<h3 v-if="index === 0">{{ ank.anketo_type_name }}</h3>
				<h3 v-else-if="(ank.anketo_type_id) !== (ank_lists[index - 1].anketo_type_id)">{{ ank.anketo_type_name }}</h3>
				<dt v-if="ank.freetext !== 1" class="necessary detail_title">{{ ank.anketo_field_name }}</dt>
				<dt v-else class="detail_title">{{ ank.anketo_field_name }}</dt>
				<!-- 複数選択 -->
				<dd v-if="ank.multiselect === 1">
					<span class="hinttext">（複数選択可）</span>
					<ul>
						<li v-if="ank.anketo_kaito_1"><input type="checkbox" :id="ank.id + '-1'" v-model="kaito[index]" value="anketo_kaito_1"><label :for="ank.id + '-1'">{{ ank.anketo_kaito_1 }}</label></li>
						<li v-if="ank.anketo_kaito_2"><input type="checkbox" :id="ank.id + '-2'" v-model="kaito[index]" value="anketo_kaito_2"><label :for="ank.id + '-2'">{{ ank.anketo_kaito_2 }}</label></li>
						<li v-if="ank.anketo_kaito_3"><input type="checkbox" :id="ank.id + '-3'" v-model="kaito[index]" value="anketo_kaito_3"><label :for="ank.id + '-3'">{{ ank.anketo_kaito_3 }}</label></li>
						<li v-if="ank.anketo_kaito_4"><input type="checkbox" :id="ank.id + '-4'" v-model="kaito[index]" value="anketo_kaito_4"><label :for="ank.id + '-4'">{{ ank.anketo_kaito_4 }}</label></li>
						<li v-if="ank.anketo_kaito_5"><input type="checkbox" :id="ank.id + '-5'" v-model="kaito[index]" value="anketo_kaito_5"><label :for="ank.id + '-5'">{{ ank.anketo_kaito_5 }}</label></li>
						<li v-if="ank.anketo_kaito_6"><input type="checkbox" :id="ank.id + '-6'" v-model="kaito[index]" value="anketo_kaito_6"><label :for="ank.id + '-6'">{{ ank.anketo_kaito_6 }}</label></li>
						<li v-if="ank.anketo_kaito_7"><input type="checkbox" :id="ank.id + '-7'" v-model="kaito[index]" value="anketo_kaito_7"><label :for="ank.id + '-7'">{{ ank.anketo_kaito_7 }}</label></li>
						<li v-if="ank.anketo_kaito_8"><input type="checkbox" :id="ank.id + '-8'" v-model="kaito[index]" value="anketo_kaito_8"><label :for="ank.id + '-8'">{{ ank.anketo_kaito_8 }}</label></li>
						<li v-if="ank.anketo_kaito_9"><input type="checkbox" :id="ank.id + '-9'" v-model="kaito[index]" value="anketo_kaito_9"><label :for="ank.id + '-9'">{{ ank.anketo_kaito_9 }}</label></li>
						<li v-if="ank.anketo_kaito_10"><input type="checkbox" :id="ank.id + '-10'" v-model="kaito[index]" value="anketo_kaito_10"><label :for="ank.id + '-10'">{{ ank.anketo_kaito_10 }}</label></li>
					</ul>
				</dd>
				<!-- 記述 -->
				<dd v-else-if="ank.freetext === 1">
					<textarea name="" id="" cols="30" rows="10" v-model="kaito[index]"></textarea>
				</dd>
				<!-- 一択 -->
				<dd v-else>
					<ul>
						<li v-if="ank.anketo_kaito_1"><input type="radio" :name="ank.id + '-1'" :id="ank.id + '-1'" v-model="kaito[index]" value="anketo_kaito_1"><label :for="ank.id + '-1'">{{ ank.anketo_kaito_1 }}</label></li>
						<li v-if="ank.anketo_kaito_2"><input type="radio" :name="ank.id + '-1'" :id="ank.id + '-2'" v-model="kaito[index]" value="anketo_kaito_2"><label :for="ank.id + '-2'">{{ ank.anketo_kaito_2 }}</label></li>
						<li v-if="ank.anketo_kaito_3"><input type="radio" :name="ank.id + '-1'" :id="ank.id + '-3'" v-model="kaito[index]" value="anketo_kaito_3"><label :for="ank.id + '-3'">{{ ank.anketo_kaito_3 }}</label></li>
						<li v-if="ank.anketo_kaito_4"><input type="radio" :name="ank.id + '-1'" :id="ank.id + '-4'" v-model="kaito[index]" value="anketo_kaito_4"><label :for="ank.id + '-4'">{{ ank.anketo_kaito_4 }}</label></li>
						<li v-if="ank.anketo_kaito_5"><input type="radio" :name="ank.id + '-1'" :id="ank.id + '-5'" v-model="kaito[index]" value="anketo_kaito_5"><label :for="ank.id + '-5'">{{ ank.anketo_kaito_5 }}</label></li>
						<li v-if="ank.anketo_kaito_6"><input type="radio" :name="ank.id + '-1'" :id="ank.id + '-6'" v-model="kaito[index]" value="anketo_kaito_6"><label :for="ank.id + '-6'">{{ ank.anketo_kaito_6 }}</label></li>
						<li v-if="ank.anketo_kaito_7"><input type="radio" :name="ank.id + '-1'" :id="ank.id + '-7'" v-model="kaito[index]" value="anketo_kaito_7"><label :for="ank.id + '-7'">{{ ank.anketo_kaito_7 }}</label></li>
						<li v-if="ank.anketo_kaito_8"><input type="radio" :name="ank.id + '-1'" :id="ank.id + '-8'" v-model="kaito[index]" value="anketo_kaito_8"><label :for="ank.id + '-8'">{{ ank.anketo_kaito_8 }}</label></li>
						<li v-if="ank.anketo_kaito_9"><input type="radio" :name="ank.id + '-1'" :id="ank.id + '-9'" v-model="kaito[index]" value="anketo_kaito_9"><label :for="ank.id + '-9'">{{ ank.anketo_kaito_9 }}</label></li>
						<li v-if="ank.anketo_kaito_10"><input type="radio" :name="ank.id + '-1'" :id="ank.id + '-10'" v-model="kaito[index]" value="anketo_kaito_10"><label :for="ank.id + '-10'">{{ ank.anketo_kaito_10 }}</label></li>
					</ul>
				</dd>
				<dd v-if="errors[index].message" class="error">{{ errors[index].message }}</dd>
			</dl>
			<div class="center">
				<button class="btn_on" @click="toConfirm">確認する</button>
			</div>
		</div>
	<!-- </div> -->
	
	<!-- <div class="center">
		<button class="btn_on" @click="toConfirm">確認する</button>
	</div> -->
	<!-- {{kaito}} -->
</div>
<div v-if="state === 2">
	<h2>{{ first_list.anketo_name }} - 確認</h2>
	<div class="myinput_area">
		<p class="center">以下の内容で送信してよろしいですか？</p>
		<div>
			<dl v-for="(ank, index) in ank_lists" :key="ank.id">
			<h3 v-if="index === 0">{{ ank.anketo_type_name }}</h3>
			<h3 v-else-if="(ank.anketo_type_id) !== (ank_lists[index - 1].anketo_type_id)">{{ ank.anketo_type_name }}</h3>
			<dt v-if="ank.freetext !== 1" class="necessary detail_title">{{ ank.anketo_field_name }}</dt>
			<dt v-else class="detail_title">{{ ank.anketo_field_name }}</dt>
				<!-- 複数選択 -->
				<dd v-if="ank.multiselect === 1">
					<ul>
						<li v-if="(ank.anketo_kaito_1) && ((kaito[index]).includes('anketo_kaito_1'))">{{ ank.anketo_kaito_1 }}</li>
						<li v-if="(ank.anketo_kaito_2) && ((kaito[index]).includes('anketo_kaito_2'))">{{ ank.anketo_kaito_2 }}</li>
						<li v-if="(ank.anketo_kaito_3) && ((kaito[index]).includes('anketo_kaito_3'))">{{ ank.anketo_kaito_3 }}</li>
						<li v-if="(ank.anketo_kaito_4) && ((kaito[index]).includes('anketo_kaito_4'))">{{ ank.anketo_kaito_4 }}</li>
						<li v-if="(ank.anketo_kaito_5) && ((kaito[index]).includes('anketo_kaito_5'))">{{ ank.anketo_kaito_5 }}</li>
						<li v-if="(ank.anketo_kaito_6) && ((kaito[index]).includes('anketo_kaito_6'))">{{ ank.anketo_kaito_6 }}</li>
						<li v-if="(ank.anketo_kaito_7) && ((kaito[index]).includes('anketo_kaito_7'))">{{ ank.anketo_kaito_7 }}</li>
						<li v-if="(ank.anketo_kaito_8) && ((kaito[index]).includes('anketo_kaito_8'))">{{ ank.anketo_kaito_8 }}</li>
						<li v-if="(ank.anketo_kaito_9) && ((kaito[index]).includes('anketo_kaito_9'))">{{ ank.anketo_kaito_9 }}</li>
						<li v-if="(ank.anketo_kaito_10) && ((kaito[index]).includes('anketo_kaito_10'))">{{ ank.anketo_kaito_10 }}</li>
						<li class="warn_red" v-else-if="kaito[index].length === 0">未回答</li>
					</ul>
				</dd>
				<!-- 記述 -->
				<dd v-else-if="ank.freetext === 1">
					<ul>
						<li class="warn_red" v-if="kaito[index].length === 0">未回答</li>
						<li v-else>{{ kaito[index] }}</li>
					</ul>
				</dd>
				<!-- 一択 -->
				<dd v-else>
					<ul>
						<li v-if="(ank.anketo_kaito_1) && (kaito[index]).includes('anketo_kaito_1')">{{ ank.anketo_kaito_1 }}</li>
						<li v-if="(ank.anketo_kaito_2) && (kaito[index]).includes('anketo_kaito_2')">{{ ank.anketo_kaito_2 }}</li>
						<li v-if="(ank.anketo_kaito_3) && (kaito[index]).includes('anketo_kaito_3')">{{ ank.anketo_kaito_3 }}</li>
						<li v-if="(ank.anketo_kaito_4) && (kaito[index]).includes('anketo_kaito_4')">{{ ank.anketo_kaito_4 }}</li>
						<li v-if="(ank.anketo_kaito_5) && (kaito[index]).includes('anketo_kaito_5')">{{ ank.anketo_kaito_5 }}</li>
						<li v-if="(ank.anketo_kaito_6) && (kaito[index]).includes('anketo_kaito_6')">{{ ank.anketo_kaito_6 }}</li>
						<li v-if="(ank.anketo_kaito_7) && (kaito[index]).includes('anketo_kaito_7')">{{ ank.anketo_kaito_7 }}</li>
						<li v-if="(ank.anketo_kaito_8) && (kaito[index]).includes('anketo_kaito_8')">{{ ank.anketo_kaito_8 }}</li>
						<li v-if="(ank.anketo_kaito_9) && (kaito[index]).includes('anketo_kaito_9')">{{ ank.anketo_kaito_9 }}</li>
						<li v-if="(ank.anketo_kaito_10) && (kaito[index]).includes('anketo_kaito_10')">{{ ank.anketo_kaito_10 }}</li>
						<li class="warn_red" v-else-if="kaito[index].length === 0">未回答</li>
					</ul>
				</dd>
			</dl>
		</div>
		<div class="center">
			<button @click="toReturn" class="btn_cancel">戻る</button>
			<button @click="onSubmit" class="btn_on">送信</button>
		</div>
	</div>

	<!-- <p>{{kaito}}</p> -->
	<!-- <div class="center">
		<button @click="toReturn" class="btn_off">戻る</button>
		<button @click="onSubmit" class="btn_on">送信</button>
	</div> -->
</div>
<div v-if="state === 3">
	<h2>送信完了</h2>
	<div class="myinput_area">
		<p class="center">ご協力ありがとうございました。</p>
		<!-- <p>ボランティア活動への参加をお待ちしております。</p> -->
		<!-- {{ submit }} -->
		<div class="center">
			<router-link to="/mypage"><button class="btn_on">終了</button></router-link>
		</div>
	</div>
</div>
</template>

<script>
import { inject } from 'vue';
import axios from 'axios';
export default {
	setup() {
		const { login } = inject('loginstate');
		return {
			login,
		}
	},
	data() {
		return {
			// アンケート質問
			ank_lists: [],
			first_list: [],
			// アンケート量
			Length: 0,
			// 画面表示コード
			state: 1,
			// アンケート回答
			kaito: [],
			// エラー用配列
			errors: [],
			// アンケート確認用
			submit: [],
		}
	},
	async created(){
		// アンケート読み込み
		// アンケート番号
		const num = 1;
		let res = await axios.get('/api/anketo?id='+ num)
		console.log(res.data)
		this.ank_lists = res.data
		// 最初のタイトル・文章読み込むため
		this.first_list = res.data[0]
		console.log(res.data[0])

		// アンケートの空配列用意
		this.Length = this.ank_lists.length;
		for(var i = 0; i < this.Length; i++){
			// 回答空配列
			this.kaito[i] = []
			this.errors[i] = []
			// エラー用配列
			if(this.ank_lists[i].freetext !== 1){
				this.errors[i] = { "message": "" }
			}
		}
	},
	methods: {
		// 確認画面へ
		toConfirm: function () {
			// error
			let num = 0;
			for(var k = 0; k < this.errors.length; k++){
				if((this.errors[k].message === "") || (this.errors[k].message === "必須項目です。")){
					if(this.kaito[k].length === 0) {
						this.errors[k].message = "必須項目です。"
						num++;
					} else {
						this.errors[k].message = ""
					}
				}
			}
			// console.log(num)
			if (num > 0){
				console.log('still have error')
			} else {
				// バリデーション後
				this.state = 2;
				// スクロールトップへ
				window.scrollTo({
					top: 0
				});
			}
		},
		// 送信
		onSubmit: async function () {
			// 情報送信
			// 送信用にデータ加工
			for(var j = 0; j < this.Length; j++) {
				this.submit.push(
					{
						"katudosya_id": this.login.id,
						// アンケートID・依頼ID（仮の値）
						// "anketo_id": 1,
						// "anketo_irai_id": 1,
						// 各アンケート情報
						"anketo_type_id": this.ank_lists[j].anketo_type_id,
						"anketo_field_id": this.ank_lists[j].anketo_field_id,
						// 回答情報
						"anketo_freetext": ((this.ank_lists[j].freetext === 1) && (this.kaito[j].length !== 0) ? this.kaito[j] : null),
						"anketo_kaito_1": ((this.ank_lists[j].freetext === 0) && (this.kaito[j].includes('anketo_kaito_1')) ? 1 : null),
						"anketo_kaito_2": ((this.ank_lists[j].freetext === 0) && (this.kaito[j].includes('anketo_kaito_2')) ? 1 : null),
						"anketo_kaito_3": ((this.ank_lists[j].freetext === 0) && (this.kaito[j].includes('anketo_kaito_3')) ? 1 : null),
						"anketo_kaito_4": ((this.ank_lists[j].freetext === 0) && (this.kaito[j].includes('anketo_kaito_4')) ? 1 : null),
						"anketo_kaito_5": ((this.ank_lists[j].freetext === 0) && (this.kaito[j].includes('anketo_kaito_5')) ? 1 : null),
						"anketo_kaito_6": ((this.ank_lists[j].freetext === 0) && (this.kaito[j].includes('anketo_kaito_6')) ? 1 : null),
						"anketo_kaito_7": ((this.ank_lists[j].freetext === 0) && (this.kaito[j].includes('anketo_kaito_7')) ? 1 : null),
						"anketo_kaito_8": ((this.ank_lists[j].freetext === 0) && (this.kaito[j].includes('anketo_kaito_8')) ? 1 : null),
						"anketo_kaito_9": ((this.ank_lists[j].freetext === 0) && (this.kaito[j].includes('anketo_kaito_9')) ? 1 : null),
						"anketo_kaito_10": ((this.ank_lists[j].freetext === 0) && (this.kaito[j].includes('anketo_kaito_10')) ? 1 : null)
					}
				);
			}

			// 送信axios
			const res = await axios.put('/api/anketo', this.submit)
			// console.log(this.submit[0].anketo_type_id === 1)
			// console.log(this.submit[0].anketo_kaito_1 === null)
			console.log(res)
			if (res) {
				// 完了画面へ。
				this.state = 3;
				// スクロールトップへ
				window.scrollTo({
					top: 0
				});

				// アンケート通知確認
				this.login.anketo = false;
				// お知らせの拡張を考えるとデータ読み込みの方がいいが...?
				// const anketo = async () => {
				// 	const res = await axios.get('/api/anketo/exists')
				// 	this.login.anketo = res.data.jyotai;
				// 	this.login.iraidate = res.data.irai_date;
				// }
				// anketo();
			}
		},
		// 戻る
		toReturn: function () {
			this.state = 1;
		},
	},
}
</script>